import { render, staticRenderFns } from "./pasteFiles.vue?vue&type=template&id=1fce5baf"
import script from "./pasteFiles.vue?vue&type=script&lang=js"
export * from "./pasteFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports